<template>
  <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    <div class="searchlist">
      <div class="header">
        <div class="pha">
          <div class="pha-content">
            <div class="phaname">
              <span>荷叶健康</span>
            </div>
          </div>
          <div :class="['msg', {'dot': item}]" @click="goMessageList">
            <img src="../../icons/home/tips.png" />
          </div>
        </div>
        
        <div class="ad-component" v-if="adUrls">
          <div class="ad-wrap">
            <van-swipe  :autoplay="4000" indicator-color="white">
              <van-swipe-item v-for="(item,index) in adUrls" :key="index">
                <van-image
                  class="adImg"
                  :src="item.url"
                  @click="jumpToUrl(item)"
                />
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        
      </div>
      <div class="conts">
        <div class="gold-physican">
          <h4>金牌服务医生</h4>
          <div v-if="physicanList.length==0" class="noDocWrap">
            <img class="noDoc" src="../../icons/noDoc.png" alt />
            <span class="noDocText">当前暂无医生~</span>
          </div>
          <ul v-if="physicanList.length>0">
            <li v-for="(doctor, key) in physicanList" :key="key">
              <van-image width="75" height="75" round :src="doctor.photoUrl" />
              <p class="doctorName">{{ doctor.doctorName }}</p>
              <p>
                <span>{{ doctor.experience }}年经验</span>
              </p>
            </li>
          </ul>
        </div>
        <div class="gopha">
          <p :class="['tip', {'visible': desc}]">
            <van-icon name="warning-o" />
            {{ desc }}
          </p>
        </div>
      </div>
      <div style="height:1.5rem" />
      <van-button
        v-online-click="goInquiry"
        :class="{'android':client=='android' || client === 'pad' || (version !== '1.3.0' && iphone)}"
        color="#01B956"
      >去问诊</van-button>
    </div>
  </van-pull-refresh>
</template>
<script>
import {
  checkIfOpen,
  getNoreadMessage,
  physicanStatus,
  getGoldPhysicans,
  getBanner,
  checkBtermInquiryPermission
} from '../../api/index'
import { toast } from '../../components/Toast'
import { Toast } from 'vant'
import { getCookie } from '../../utils/auth'
import { initLog } from '@/utils/'
import db from '@/utils/db'
import ad1 from '../../icons/banner.jpg'
import ad2 from '../../icons/banner2.png'
import ad3 from '../../icons/ads2.jpg'
import ad4 from '../../icons/ads3.jpg'
import { getInsuranceImage } from '../../utils/index'
export default {
  data() {
    return {
      adUrls:[
      ],
      iphone: false,
      version: '',
      isLoading: false,
      doctorOnlineState: 0,
      desc: '',
      timer: null,
      visible: false,
      physicanList: [],
      item: 0,
      active: 0,
      value: '',
      namelist: [],
      length: '',
      organSign: '',
      wsuri: '',
      url: '',
      flag: true,
      client: ''
    }
  },
  computed: {
    getStateNews() {
      return this.$store.state.app.news
    }
  },
  watch: {
    getStateNews(curVal, oldVal) {
      this.init()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.doctorOnlineState = 0
    this.desc = ''
  },
  created() {
    const client = getCookie('native_client') || ''
    if (client === 'android' || client === 'ios' || client === 'pad') {
      this.organSign = getCookie('native_organSign')
    } else {
      this.organSign = getCookie('organSign')
    }

    this.version = getCookie('native_version')
    this.iphone = this.isIphonex()
    clearInterval(this.timer)
    // 获取未读消息数量
    this.init()
    this.getBanners()
    // 医生状态,最后替换注释的时间
    // setTimeout(this.getPhysicanStatus, 18e4)
    this.timer = setInterval(this.getPhysicanStatus, 18e4)
    this.client = getCookie('native_client')
    setTimeout(() => {
      window.location.href = `protocol://action/showBottomTab`
    }, 500)
    window.webSdk.track('ds_page_home_banner', {
      drugstoreName:getCookie('native_drugstoreName'),
      organSign:getCookie('native_organSign'),
      seq:1
    })
    
    console.log("我就是来测试灰度的");
  },
  methods: {
    /**
     * @description: 获取banner
     * @param {Number} tag 查询类型 1.banner 2.启动页
     * @param {Number} status 启用状态 1.启用 2.禁用
     * @return 
    */
   async getBanners(){
     const params = {
       tag:1,
       status:1
     }
     const res = await getBanner(params)
     if(res.code === 0){
       this.adUrls = res.result
     }
   },
    curVersion(num) {
      const appVersion = getCookie("native_version") || "1.0.0";
      const version = appVersion.split(".").join("");
      return parseInt(version) >= num;
    },
    jumpToUrl(item) {
      window.webSdk.track('ds_click_home_banner', {
        organSign: getCookie('native_organSign'),
        diagnosis_name: getCookie('native_drugstoreName'),
        accountId: getCookie('native_accountId'),
        index: 1
      })
      window.webSdk.track('click_banner', {
        organSign: getCookie('native_organSign'),
        diagnosis_name: getCookie('native_drugstoreName'),
        id:item.adId,
        name:item.name,
        time:new Date().toLocaleString()        
      })
      if (this.curVersion(216)) {
        window.location.href = `protocol://action/ad?tag=${item.tag}&url=${encodeURIComponent(item.linkAddress)}&title=${item.name}&linkType=${item.linkType}`; // 加个linkType
      }
    },
    isIphonex() {
      if (typeof window !== 'undefined' && window) {
        return (
          /iphone/gi.test(window.navigator.userAgent) &&  
          window.screen.height >= 812
        )
      }
      return false
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false
        clearInterval(this.timer)
        this.init()
        this.timer = setInterval(this.getPhysicanStatus, 18e4)
      }, 500)
    },
    // 金牌医生接口
    async getGoldPhysicans() {
      try {
        const res = await getGoldPhysicans({ doctorStatus: 1 })
        if (res.data.code === 0) {
          this.physicanList = res.data.result
          this.physicanList.forEach(element => {
            element.photoUrl = getInsuranceImage(element.photoUrl)
          });
        }
      } catch (errs) {
        console.log('errs', errs)
      }
    },
    // 获取医生状态
    async getPhysicanStatus() {
      try {
        const res = await physicanStatus({ organSign: this.organSign })
        if (res.data.code === 0) {
          this.doctorOnlineState = res.data.result.doctorOnlineState
          this.desc = res.data.result.desc
        } else {
          this.doctorOnlineState = 0
          this.desc = ''
        }
      } catch (err) {
        console.log('err', err)
      }
    },
    async init() {
      try {
        if (this.flag) {
          this.flag = false
          const res = await getNoreadMessage({ organSign: this.organSign })
          this.item = res.result
        } else if (this.$store.state.app.news !== 0) {
          this.item += this.$store.state.app.news
        }

        console.log('消息格式', this.$store.state.app.news)
        // 获取医生出诊状态
        this.getPhysicanStatus()
        // 获取金牌医生数据
        this.getGoldPhysicans()
      } catch (error) {
        console.error(error)
      }
    },
    async goToPage() {
      try {
        const res = await checkIfOpen({ organSign: this.organSign })
        this.setLog({
          message: '验证医生权限接口成功',
          type: '/home'
        })
        console.log('验证权限result', res)
        if (res.result !== false) {
          let page = 'interrogationInfoText';
          this.$router.push(page)
        } else {
          toast('您还未开通远程处方服务，如需开通请联系客服电话400-0919-990')
        }
      } catch (error) {
        this.setLog({
          message: '验证医生权限接口异常',
          type: '/home'
        })
        console.error(error)
      }
    },
    async goInquiry() {
      // 去问诊时 判断 organSign 和 app 版本 兼容商家端合 app 更新登录失效问题。
      let organSign = getCookie('native_organSign');
      let appVersion = getCookie('native_version');

      if (appVersion == '3.0.0' && (!organSign || organSign == 'null')) {
        window.location.href = 'protocol://action/logout'; // 退出登录
        db.removeItem('employeeId')
        db.removeItem('drugstoreName')
        return;
      }
      var permission = await checkBtermInquiryPermission({organSign:organSign});
      if (permission.data.code === 0) {
        if (!permission.data.result.passable) {
          return Toast(permission.data.result.tipMessage);
        }
      }else {
        return Toast(permission.data.msg);
      }
      localStorage.removeItem('params')
      const that = this
      try {
        physicanStatus({ organSign: this.organSign }).then(res => {
          if (res.data.code === 0) {
            this.doctorOnlineState = res.data.result.doctorOnlineState
            this.desc = res.data.result.desc
            // 1-有医生在线；0-无医生在线；
            if (this.doctorOnlineState) {
              checkIfOpen({ organSign: this.organSign }).then(res => {
                if (res.result !== false) {
                  localStorage.setItem('sourceId','0')
                  let page = 'interrogationInfoText';
                  this.$router.push(page)
                } else {
                  toast(
                    '您还未开通远程处方服务，如需开通请联系客服电话400-0919-990'
                  )
                }
              })
            } else {
              console.log('res.data.result', res.data.result)
              Toast(this.desc)
            }
            this.setLog({
              message: '获取医生状态接口成功',
              type: '/home'
            })
          } else {
            this.doctorOnlineState = 0
            this.desc = ''
          }
        })
      } catch (err) {
        this.setLog({
          message: '获取医生状态接口异常',
          type: '/home'
        })
        console.log('err', err)
      }
      this.setLog({
        message: '去问诊',
        type: '/home'
      })
    },
    // 去消息页面
    goMessageList() {
      if (this.item) {
        // this.websock.onclose
        this.$store.dispatch('getnews', 'clear')

        // this.$router.push({ path: 'news' })
      }
      this.$router.push({ path: 'news' })
    },
    /**
     * @description: 加log日志
     * @param {Object} json对象
     * @return:
     */
    setLog(msg) {
      $hyjkLoggerSdk.info(initLog(msg), "PATIENTH5");
    },
  }
}
</script>
<style scoped lang="scss">
@import '../../styles/search.css';
#app {
  height: 100vh;
}
.searchlist {
  width: 375px;
  background: #fff;
  position: relative;
  * {
    margin: 0;
    padding: 0;
  }
}
.header {
  position: relative;
  .msg {
    position: absolute;
    width: 22px;
    height: 22px;
    top: 12px;
    right: 15px;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 22px;
      height: 22px;
    }
    &.dot {
      &:before {
        content: '';
        position: absolute;
        width: 6px;
        height: 6px;
        background: #fa5523;
        border-radius: 50%;
        right: 0;
        top: -3px;
      }
    }
  }
  .pha {
    position: relative;
    .pha-content {
      display: flex;
      width: 100%;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      .phaname {
        width: 100%;
        font-size: 22px;
        font-weight: 500;
        color: #fff;
        margin-bottom: 3px;
        span {
          color: #333;
            font-size: 20px;
        }
      }
      .remind {
        font-size: 14px;
        font-size: 400;
        color: #fff;
      }
    }
  }
  .ad-component {
    width:calc(100% - 30px);
    padding: 10px 15px 0;
    /deep/ img {
      width: 100%;
      height: 110px;
      border-radius: 8px;
      background: #000;
    }
  }
  .ad-wrap{
    width:100%;
    overflow: hidden;
  }
}
.header .van-tabbar-item__text img {
  width: 22px;
  height: 20px;
}
.header .van-tabbar-item /deep/.van-info {
  top: -0.1rem;
  right: -6px;
  padding: 1px 0.5px 0 0;
  box-sizing: border-box;
}
.header .van-tabbar--fixed {
  position: fixed;
  width: 44px;
  height: 44px;
  right: 20px;
  top: 10px;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.header .van-tabbar-item--active {
  position: absolute;
  width: 100%;
  height: 100%;
}

// @media screen and (max-height: 812px) {
.conts {
  position: relative;
  text-align: center;
  .gold-physican {
    margin: 0 0 0 15px;
    padding-bottom: 15px;
    width: 345px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 12px 0px rgba(48, 48, 60, 0.08);
    border-radius: 8px;
    border: 1px solid rgba(238, 242, 244, 1);
    h4 {
      text-align: left;
      margin: 18px;
      padding-left: 27px;
      font-size: 20px;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
      background: url('../../icons/home/gold.png') no-repeat;
      background-size: 22px 22px;
      background-position: left center;
    }
    ul {
      padding: 0 15px;
      text-align: left;
      display: flex;
      flex-wrap: wrap;
      li {
        display: inline-block;
        width: 75px;
        margin: 0 15px 15px;
        text-align: center;
        display: flex;
        flex-direction: column;
        img {
          // width: 75px;
          // height: 75px;
          // border-radius: 50%;
          margin-bottom: 15px;
        }
        p {
          color: #333;
          font-weight: 400;
          font-size: 17px;
          span {
            font-size: 15px;
            color: #666;
          }
        }
        .doctorName {
          margin-bottom: 2px;
        }
      }
    }
  }
}
// }
@media screen and (max-height: 667px) {
  .conts {
    position: relative;
    text-align: center;
    .gold-physican {
      margin: 0 0 0 15px;
      padding-bottom: 15px;
      width: 345px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 12px 0px rgba(48, 48, 60, 0.08);
      border-radius: 8px;
      border: 1px solid rgba(238, 242, 244, 1);
      h4 {
        text-align: left;
        margin: 18px;
        padding-left: 27px;
        font-size: 20px;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
        background: url('../../icons/home/gold.png') no-repeat;
        background-size: 22px 22px;
        background-position: left center;
      }
      ul {
        padding: 0 15px;
        text-align: left;
        display: flex;

        li {
          display: inline-block;
          width: 70px;
          margin: 0 15px 10px;
          text-align: center;
          display: flex;
          flex-direction: column;
          img {
            // width: 75px;
            // height: 75px;
            // border-radius: 50%;
            margin-bottom: 10px;
          }
          p {
            color: #333;
            font-weight: 400;
            font-size: 17px;
            span {
              font-size: 15px;
              color: #666;
            }
          }
        }
      }
    }
  }
}
.van-button--normal {
  width: 200px;
  height: 50px;
  border-radius: 24px;
  border: none;
  &.disabled {
    background: #c8c8c8 !important;
  }
}
.van-button {
  line-height: 38px;
  position: absolute;
  bottom: 30px;
  left: calc(50% - 100px);
}
.android {
  bottom: 75px;
}
.van-button__text {
  font-size: 18px;
  font-weight: 500;
  color: #fff;
}
.gopha {
  display: inline-block;
  .tip {
    text-align: left;
    width: 345px;
    line-height: 44px;
    margin: 15px 0 21px;
    font-size: 14px;
    background: rgba(255, 251, 230, 1);
    border-radius: 8px;
    color: #656565;
    border: 1px solid rgba(255, 229, 143, 1);
    visibility: hidden;
    &.visible {
      visibility: visible;
    }
    .van-icon {
      margin: 0 10px 0 23px;
      font-size: 20px;
      vertical-align: text-top;
      color: #f8ad15;
    }
  }
}
.noDocWrap {
  display: flex;
  flex-direction: column;
  .noDoc {
    margin: 22px auto 0;
    width: 148px;
    height: 92px;
  }
  .noDocText {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 23px;
    margin: 20px auto 0;
  }
}

/* 调整小图标 */
.searchlist /deep/ .van-info {
  border: 0.02667rem solid #ee0a24;
}
/deep/ .van-swipe__indicators{
  margin-bottom:6px;
}
 .adImg{
   width:100%;
   height:110px;
   overflow:hidden;
 }
 
</style>
